export const ImageDesc94 = {
    title: "Image 94:  Example of accessible entrance to a bank ATM.",
    para1: "The image shows the entrance to a State Bank of India (SBI) ATM located on a street corner. The ATM has an entrance with a short staircase and an accessible entrance with a ramp. The entrance with the ramp has railings on both sides, which allows people with wheelchairs or other mobility impairments to easily access the ATM. The ATM itself is located in a corner of a building with the SBI logo and branding visible. "
}

export const ImageDesc95 = {
    title: "Image 95: Example of accessible ATM provisions.",
    para1: "This image has two pictures showing accessible ATM provisions at Union Bank of India ATMs. The image on the left shows a person in a wheelchair accessing the ATM. The image on the right shows a visually impaired person with a cane accessing the ATM. "
}

export const ImageDesc96 = {
    title: "Image 96: Example of accessible retail spaces.",
    para1: `This image depicts an accessible retail space. Its layout is inclusive and has lowered shelves, enhancing accessibility for all the diverse customers. The store offers a diverse range of products including books, toys, and trinkets. The store's name "BookScetra", in shown in bilingual signage i.e. both English and Hindi.`
}

export const ImageDesc97 = {
    title: "Image 97: Example of outdoor area for retail spaces.",
    para1: "This image shows an inclusive outdoor retail space, showcasing books thoughtfully arranged on lowered trolleys. Notably, the design prioritizes accessibility by widening the spaces within the trolleys, ensuring convenient movement for wheelchair users, and enhancing the overall inclusivity of the space."
}

export const ImageDesc98 = {
    title: "Image 98: Example of accessible entrance to an eatery.",
    para1: "This image shows an example of an accessible entrance to an eatery. The entrance is sloped to make it accessible for diverse user groups."
}